import { isEmpty } from 'ramda'
import { useChangeSearch, useFilter, useSearch } from '@btime/react-contexts'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { Col, Grid } from '../../../packages/kiti/components/structure/Grid'
import { useForm } from './_load/FormLoader'
import FiltersBar from './filters/FiltersBar'
import FormResumeViewSelect from '../../forms/_shared/FormResumeViewSelect'
import IconButton from '../../../components/actions/IconButton'
import SearchInput from '../../../components/form/SearchInput'
import Separator from '../../../packages/kiti/components/helpers/Separator'

const ControlBar = () => {
  const { t } = useTranslation()

  const form = useForm()
  const hasFilter = !isEmpty(useFilter())
  const [isFiltering, setFiltering] = React.useState(hasFilter)
  const hideFilter = () => setFiltering(false)
  const toggleFilter = () => setFiltering(!hasFilter ? !isFiltering : true)

  const changeSearch = useChangeSearch()
  const search = useSearch()

  return (
    <>
      <Separator weight={4} />
      <Grid justify="space-between" gutter={0.4}>
        <Col>
          <FormResumeViewSelect form={form} value="list" />
        </Col>

        <Col>
          <IconButton iconLeft="BsFunnel" label={t('filter')} transparent noWrap onClick={toggleFilter} />
        </Col>

        <Col flex={3} />
        <Col flex={1}>
          <SearchInput value={search} onStopTyping={changeSearch} />
        </Col>
      </Grid>
      <Separator weight={8} />

      <FiltersBar open={isFiltering} onClose={hideFilter} />
    </>
  )
}

export default ControlBar
